import React from "react";

function Header() {
  return (
    <header>
      <h1 className="heading">Emojibase</h1>
    </header>
  );
}

export default Header;
